import * as bs from 'bootstrap';

import { initDataModal } from './behaviours/DataModal';
import { initDataToast } from './behaviours/DataToast';
import { initCustomElements } from './behaviours/CustomElements';
import { initDataHref } from './behaviours/DataHref';
import { initDataPaste } from './behaviours/DataPaste';
import { initDataColourPicker } from './behaviours/DataColourPicker';

export { bs };

initDataModal();
initDataToast();
initDataHref();
initCustomElements();
initDataPaste();
initDataColourPicker();
